import React, { useState } from "react";

import "./ConsultReport.css";

import ConsultReportCrudLoad from "./ConsultReportCrudLoad";
import ConsultReportHeader from "./ConsultReportHeader";
import ConsultReportTabs from "./ConsultReportTabs";
import ConsultReportSections from "./ConsultReportSections";
import { REPORT_CONFIG, REPORT_OPTIONS } from "./ConsultReportConfig";

const ConsultReportCrud = () => {
    const [data, setData] = useState(null);
    const [indice, setIndice] = useState(0);
    const [ocultarVacios, setOcultarVacios] = useState(true);
    const [enmascarar, setEnmascarar] = useState(true);
    const [tipoReporte, setTipoReporte] = useState("B2C_PEDIDOS");

    const config = REPORT_CONFIG[tipoReporte];

    const handleLoad = (json) => {
        setData(json);
        setIndice(0);
    };

    const handleTipoReporte = (e) => {
        setTipoReporte(e.target.value);
        setData(null);
        setIndice(0);
    };

    const registros = data?.reporte || [];
    const registro = registros[indice];

    return (
        <div className="container-fluid reporte-pedidos">

            <div className="barra">

                <h4 className="titulo">
                    {config.titulo}
                </h4>

                <div className="selector-reporte">
                    <label htmlFor="tipoReporte">
                        Tipo de reporte
                    </label>

                    <select
                        id="tipoReporte"
                        className="form-select form-select-sm"
                        value={tipoReporte}
                        onChange={handleTipoReporte}
                    >
                        {REPORT_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                {data && (
                    <div className="estado-api">
                        <span className={`chip ${data.success ? "ok" : "error"}`}>
                            success <b>{data.success ? "sí" : "no"}</b>
                        </span>

                        <span className="chip">
                            status <b>{data.status}</b>
                        </span>

                        <span className="chip">
                            registros <b>{data.count ?? registros.length}</b>
                        </span>

                        <span className="chip">
                            <b>{data.message}</b>
                        </span>
                    </div>
                )}

                <div className="controles">

                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={ocultarVacios}
                            onChange={(e) => setOcultarVacios(e.target.checked)}
                        />
                        <span>Ocultar campos vacíos</span>
                    </label>

                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={enmascarar}
                            onChange={(e) => setEnmascarar(e.target.checked)}
                        />
                        <span>Enmascarar datos sensibles</span>
                    </label>

                    <ConsultReportCrudLoad onLoad={handleLoad} />

                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => window.print()}
                        disabled={!registro}
                    >
                        Imprimir
                    </button>

                </div>
            </div>

            {registros.length > 1 && (
                <ConsultReportTabs
                    registros={registros}
                    indice={indice}
                    onSelect={setIndice}
                    config={config.tab}
                />
            )}

            {registro && (
                <>
                    <ConsultReportHeader
                        registro={registro}
                        config={config.header}
                        tipo={config.tipo}
                    />

                    <ConsultReportSections
                        registro={registro}
                        ocultarVacios={ocultarVacios}
                        enmascarar={enmascarar}
                        secciones={config.secciones}
                    />
                </>
            )}

            {data && registros.length === 0 && (
                <p className="text-muted mt-3">
                    El reporte no trae registros.
                </p>
            )}
        </div>
    );
};

export default ConsultReportCrud;
